import bigInt from "big-integer";
import _ from "lodash";

export type SeededRandomFunction = () => number;

// Creates a seeded random number generator using [xorshift](https://en.wikipedia.org/wiki/Xorshift)
// Output between 0 and 1
// Maintains 32 bits of state and outputs 16 higher bits
export function SeededRandom(seed: number): SeededRandomFunction {
  let state = bigInt(seed);

  function next() {
    state = state.xor(state.shiftLeft(13));
    state = state.xor(state.shiftRight(17));
    state = state.xor(state.shiftLeft(5));
    state = state.and(bigInt(1).shiftLeft(32).subtract(1));
    return state;
  }

  for (let i = 0; i < 10; i++) {
    next();
  }
  return () => next().shiftRight(16).toJSNumber() / (1 << 16);
}

export function seededShuffle<T>(
  seed: number | SeededRandomFunction,
  array: T[]
) {
  const rand = typeof seed === "function" ? seed : SeededRandom(seed);
  const indexes = Array(array?.length)
    .fill(0)
    .map((_v, index) => ({ index, weight: rand() }));
  return _.sortBy(indexes, v => v.weight).map(v => array[v.index]);
}
